import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

export type ThroughputDataPoint = {
  time: string
  accepted: number
  delivered: number
  bounced: number
  deferred: number
}

interface ThroughputChartProps {
  data: ThroughputDataPoint[]
}

export function ThroughputChart({ data }: ThroughputChartProps): React.JSX.Element {
  return (
    <div className="rounded-xl border border-surface-3 bg-surface-0 p-6">
      <div className="mb-4">
        <h2 className="text-sm font-medium text-text-primary">Throughput</h2>
        <p className="text-xs text-text-tertiary">Messages per second over the last ~5 minutes</p>
      </div>
      {data.length === 0 ? (
        <div className="flex h-[250px] items-center justify-center">
          <p className="text-sm text-text-tertiary">Collecting data...</p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-surface-3)" />
            <XAxis dataKey="time" stroke="var(--color-text-tertiary)" fontSize={11} />
            <YAxis stroke="var(--color-text-tertiary)" fontSize={11} />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-surface-0)',
                border: '1px solid var(--color-surface-3)',
                borderRadius: '8px',
                fontSize: '12px',
              }}
            />
            <Legend wrapperStyle={{ fontSize: '12px' }} />
            <Line
              type="monotone"
              dataKey="accepted"
              stroke="var(--color-admin-500)"
              strokeWidth={2}
              dot={false}
              name="Accepted"
            />
            <Line
              type="monotone"
              dataKey="delivered"
              stroke="var(--color-success)"
              strokeWidth={2}
              dot={false}
              name="Delivered"
            />
            <Line
              type="monotone"
              dataKey="bounced"
              stroke="var(--color-danger)"
              strokeWidth={1.5}
              dot={false}
              name="Bounced"
            />
            <Line
              type="monotone"
              dataKey="deferred"
              stroke="var(--color-warning)"
              strokeWidth={1.5}
              dot={false}
              name="Deferred"
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  )
}
